import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Header, { scrollToId } from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ShopPage from "@/pages/ShopPage";
import ConsignPage from "@/pages/ConsignPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminInbox from "@/pages/AdminInbox";
import { SHOP_ENABLED } from "@/lib/config";

function RouteEffects() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => scrollToId(id), 350);
    } else if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <RouteEffects />
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        {SHOP_ENABLED && <Route path="/shop" element={<ShopPage />} />}
        <Route path="/consign" element={<ConsignPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminInbox />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App grain">
      <SmoothScroll>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </SmoothScroll>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: { background: "#131315", border: "1px solid #262629", color: "#fff" },
        }}
      />
    </div>
  );
}

export default App;
